import { crearWhatsAppUrl } from '../../../utils/contactos';

export const createWhatsappUrl = (message = '') =>
  crearWhatsAppUrl('television', message || '');
